"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.onGifSeen = exports.onGifClick = exports.onGifHover = void 0;
var js_analytics_1 = require("@giphy/js-analytics");
var js_util_1 = require("@giphy/js-util");
var firePingback = function (actionType) { return function (gif, user, target, attributes) {
    if (attributes === void 0) { attributes = []; }
    return js_analytics_1.pingback({
        gif: gif,
        user: user,
        responseId: gif.response_id,
        type: gif.pingback_event_type,
        actionType: actionType,
        position: js_util_1.getClientRect(target),
        attributes: attributes,
    });
}; };
// these have position from the target
exports.onGifHover = firePingback('HOVER');
exports.onGifClick = firePingback('CLICK');
exports.onGifSeen = function (gif, user, position, attributes) {
    if (attributes === void 0) { attributes = []; }
    js_analytics_1.pingback({
        gif: gif,
        user: user,
        responseId: gif.response_id,
        type: gif.pingback_event_type,
        actionType: 'SEEN',
        position: position,
        attributes: attributes,
    });
};
//# sourceMappingURL=pingback.js.map